import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClInput, InputType } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';

@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.css'],
    imports: [ReactiveFormsModule, ClInput, ErrorComponent],
})
export class FormInputComponent {
    readonly control = input.required<FormControl<string>>();
    readonly label = input<string>('');
    readonly placeholder = input<string>('');
    readonly type = input<InputType>('text');
    readonly inputId = input.required<string>();
}
